import React from 'react';
import { dateI18n } from '@wordpress/date';
import fetch from 'unfetch';

const { forEach, isEmpty } = window.lodash;
const { Fragment } = wp.element;
const { PanelBody, Dashicon, ExternalLink, Button } = wp.components;
const { __ } = wp.i18n;

export default class LibraryUpdate extends React.Component {
	constructor( props ) {
		super( props );

		this.state = {
			remoteDesignLibraryMeta: false,
			localDesignLibraryVersions: false,
			updateRequired: false,
		};
	}

	componentDidMount = () => {
		this.getRemoteLibraryStatus();
		this.setLocalDesignLibraryVersions();
	};

	componentDidUpdate = prevProps => {
		if ( prevProps.importing !== this.props.importing ) {
			this.setLocalDesignLibraryVersions();
		}
	};

	/**
	 * Update design set versions based on data
	 * received from the database on the initial page load.
	 */
	setLocalDesignLibraryVersions = () => {
		if ( ! isEmpty( window.dsgnjs.designLibrary ) ) {
			const versions = {};

			forEach( window.dsgnjs.designLibrary, ( designSet, setId ) => {
				if ( ! isEmpty( designSet.version ) ) {
					versions[ setId ] = designSet.version;
				}
			} );

			if ( ! isEmpty( versions ) ) {
				this.setState(
					{
						localDesignLibraryVersions: versions,
					},
					() => {
						this.updateLibraryStatus();
					}
				);
			}
		}
	};

	updateLibraryStatus = () => {
		let uptodate = true;
		forEach( this.state.remoteDesignLibraryMeta.versions, ( version, setId ) => {
			if (
				! isEmpty( this.state.localDesignLibraryVersions[ setId ] ) &&
				this.state.localDesignLibraryVersions[ setId ] !== version
			) {
				this.setState( {
					updateRequired: setId,
				} );

				uptodate = false;
				return false; // exit early to make sure we update one set at a time.
			}
		} );

		if ( this.state.updateRequired && uptodate ) {
			this.setState( {
				updateRequired: false,
			} );
		}
	};

	updateLibrary = () => {
		this.props.importThumbnails( this.state.updateRequired );
	};

	getRemoteLibraryStatus = () => {
		fetch( 'https://wpdesignhub.com/designs/library-status.json', {
			method: 'GET',
			headers: {
				'Content-Type': 'text/plain',
			},
		} ).then( response => {
			if ( response.ok ) {
				response.json().then( remoteDesignLibraryMeta => {
					this.setState(
						{
							remoteDesignLibraryMeta: remoteDesignLibraryMeta,
						},
						() => {
							this.updateLibraryStatus();
						}
					);
				} );
			} else {
				const error = new Error( response.statusText );
				error.response = response;
				// eslint-disable-next-line no-console
				console.warn( error );
			}
		} );
	};

	render() {
		return (
			<Fragment>
				<PanelBody
					title={ __( 'Design Library Update' ) }
					initialOpen={ this.props.premiumUser }
					className={ 'dsgn__library-update' }
				>
					<Fragment>
						<div>
							{ this.props.importedPremium && this.props.importedBasic && (
								<Button
									// icon="download"
									ref={ x => ( this._button_update_library = x ) }
									className="design-upsell__cta dsgn__library-download-new-designs"
									isBusy={ this.props.importing }
									isPrimary
									isLarge
									onClick={ () => {
										this._button_update_library.blur(); // Loading animation isn't working without blur.
										this.updateLibrary();
									} }
									disabled={
										! this.props.premiumUser || ! this.state.updateRequired
									}
								>
									<Dashicon icon="download" /> { __( 'Download new designs' ) }
								</Button>
							) }
							{ ! this.props.importedBasic && (
								<Button
									className="design-upsell__cta dsgn__library-import-free"
									ref={ x => ( this._button_free_desings = x ) }
									isBusy={ this.props.importing }
									isLarge
									isPrimary
									onClick={ () => {
										this._button_free_desings.blur(); // Loading animation isn't working without blur.
										this.props.importThumbnails( 'basic' );
									} }
								>
									<Dashicon icon="download" /> { __( 'Import 50 free designs' ) }
								</Button>
							) }
							{ this.props.importedBasic &&
								this.props.premiumUser &&
								! this.props.importedPremium && (
								<Button
									className="design-upsell__cta dsgn__library-import-premium"
									isBusy={ this.props.importing }
									isLarge
									isPrimary
									ref={ x => ( this._button_premium_desings = x ) }
									onClick={ () => {
										this._button_premium_desings.blur(); // Loading animation isn't working without blur.
										this.props.importThumbnails( 'premium' );
									} }
								>
									<Dashicon icon="download" /> { __( 'Import premium designs' ) }
								</Button>
							) }

							{ this.props.importedPremium && this.props.importedBasic && (
								<Button
									className="design-upsell__cta dsgn__library-reset-versions"
									onClick={ () => {
										if ( window.dsgnjs.designLibrary.basic !== undefined ) {
											window.dsgnjs.designLibrary.basic.version = '0.0';
										}
										if ( window.dsgnjs.designLibrary.premium !== undefined ) {
											window.dsgnjs.designLibrary.premium.version = '0.0';
										}
									} }
								>
									<Dashicon icon="download" /> { __( 'Reset version numbers' ) }
								</Button>
							) }

							<ul className="dsgn-settings__data">
								{ this.props.premiumUser && this.props.importedPremium && (
									<li className="dsgn__library-status">
										<Dashicon icon="info" /> { __( 'Your library is ' ) }
										{ this.state.updateRequired && (
											<strong className="dsgn-outdated">
												{ __( 'outdated' ) }
											</strong>
										) }
										{ ! this.state.updateRequired && (
											<strong className="dsgn-uptodate">
												{ __( 'up to date' ) }
											</strong>
										) }
									</li>
								) }
								<li>
									<Dashicon icon="chart-bar" /> { __( 'Released' ) }:
									<strong>
										{ this.state.remoteDesignLibraryMeta.releasedDesigns +
											' ' +
											__( 'designs' ) }
									</strong>
									<ExternalLink
										href={
											'https://wpdesignhub.com/design-library/?utm_source=plugin-ui&utm_medium=sidebar&utm_campaign=plugins-settigns&utm_campaign=plugin-settings'
										}
										className="dsgn-settings__data-action-link"
									>
										{ __( 'library' ) }
									</ExternalLink>
								</li>
								<li>
									<Dashicon icon="calendar-alt" /> { __( 'Next Release' ) }:
									<strong>
										{ dateI18n(
											'M d, Y',
											this.state.remoteDesignLibraryMeta.nextRelease
										) }
									</strong>
								</li>
							</ul>

							<p>
								{ __(
									'We are building the biggest design library for WordPress. Our target is to have 1000 premium designs by November 2019. Every second week we release new designs and raise the price of membership accordingly.'
								) }
							</p>
						</div>
					</Fragment>
				</PanelBody>
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/library-update.jsx